/** @jsx jsx */
import { jsx } from 'theme-ui'

const Crosshair = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      sx={{ width: '100%' }}
      {...props}
    >
      <g
        id="Group_63"
        data-name="Group 63"
        transform="translate(-1854 -1014)"
        sx={{
          '> *': {
            stroke: 'red',
          },
        }}
      >
        <line
          id="Line_4"
          data-name="Line 4"
          y2="24"
          transform="translate(1866 1014)"
          fill="none"
          stroke="#d22630"
          strokeWidth="2"
        />
        <line
          id="Line_5"
          data-name="Line 5"
          x2="24"
          transform="translate(1854 1026)"
          fill="none"
          stroke="#d22630"
          strokeWidth="2"
        />
        <g
          id="Ellipse_1"
          data-name="Ellipse 1"
          transform="translate(1857 1017)"
          fill="none"
          stroke="#d22630"
          strokeWidth="2"
        >
          <circle cx="9" cy="9" r="9" stroke="none" />
          <circle cx="9" cy="9" r="8.5" fill="none" />
        </g>
      </g>
    </svg>
  )
}

export { Crosshair }
